/** Durée unique pour contour carte et texte (liste, groupes, favoris). */
export const PENDING_DOCS_BLINK_DURATION_MS = 1350;

const DELAY_VAR = '--pending-docs-blink-delay';
const DURATION_VAR = '--pending-docs-blink-duration';

/** Aligne toutes les animations sur la même phase (délai négatif = horloge partagée). */
export function applyPendingDocsBlinkSync() {
  const root = document.documentElement;
  root.style.setProperty(DURATION_VAR, `${PENDING_DOCS_BLINK_DURATION_MS}ms`);
  root.style.setProperty(
    DELAY_VAR,
    `-${Date.now() % PENDING_DOCS_BLINK_DURATION_MS}ms`
  );
}

export function clearPendingDocsBlinkSync() {
  document.documentElement.style.removeProperty(DELAY_VAR);
}
